export const ROUTES = {
    HOME: "/",
    SURVEY_START: "/survey/start",
    SURVEY_QUESTIONS: "/survey/questions",
    SURVEY_CONFIRM: "/survey/confirm",
    SURVEY_END: "/survey/thank-you",
    USER_LOGIN: "/user/login",
    USER_PROFILE: "/user/profile",
    CONTACT: "/contact",
    ABOUT: "/about",
    ERROR: "/error"

}